import React from 'react';
import PropTypes from 'prop-types';
import { DismissibleNotification, NotificationType } from 'moods-react/Notification';
import { FormattedMessage } from 'react-intl';
import Header from '../header/HeaderComponent';
import AnalyticsClient from '../../../clients/AnalyticsClient';
import accountEvents from '../../../analytics/events/account';

import './HeaderLayout.scss';

class HeaderLayoutComponent extends React.Component {
  announcement() {
    const { internalUser, name, email } = this.props.config;
    if (internalUser === false) {
      return null;
    }
    const userData = { name, email };

    document.querySelector('html').classList.add('impersonation-banner'); // eslint-disable-line compat/compat

    return (
      <div className="header-layout-component__announcement u-fontFamily-secondaryMedium">
        <FormattedMessage
          id="app.header.announcement.internalUserLogin"
          defaultMessage="Logged in as user {name} {email}"
          values={userData}
        />
      </div>
    );
  }

  closeNotification() {
    this.props.actions.dismissNotification();
    // storing notification dismissed flag into session storage because we are not persisting this info in the BE and
    // we do not want the user to see the notifications all the time btw refresh & on switching btw m4b / mbs pages.
    sessionStorage.setItem('userDismissedNotification', true);
  }

  render() {
    const announcement = this.announcement();
    const headerClass = announcement === null ? '' : 'header-layout-component__header--shifted';

    const { companyNotification } = this.props.config;

    return (
      <div className="header-layout-component">
        {announcement}
        {this.props.hasNotification && (
          <DismissibleNotification
            type={NotificationType.Information}
            className="-small"
            icon={false}
            onClose={() => {
              this.closeNotification();
              AnalyticsClient.trackEvent(accountEvents.notification('Dismiss'));
            }}
          >
            <div className="u-display-flex u-flexDirection-row u-paddingRight-xl u-paddingRight-xs@medium u-alignItems-center">
              <p className="u-flex-grow-1 u-marginBottom-0 u-color-dark u-fontFamily-secondaryMedium u-textAlign-center">
                {companyNotification.message}
              </p>
              <div className="u-display-flex u-paddingTop-m u-paddingTop-0@medium u-padding-horizontal-s@medium u-alignItems-center">
                <div
                  className="btn -ghost-dark accept-notification-button"
                  onClick={() => {
                    this.closeNotification();
                    AnalyticsClient.trackEvent(accountEvents.notification('Accept'));
                  }}
                >
                  {companyNotification.buttonText}
                </div>
              </div>
            </div>
          </DismissibleNotification>
        )}
        <Header {...this.props} headerClass={headerClass} />
        <div className="grey-out-hack" />
      </div>
    );
  }
}

HeaderLayoutComponent.displayName = 'HeaderLayout';

HeaderLayoutComponent.propTypes = {
  config: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    internalUser: PropTypes.bool,
    permissions: PropTypes.array,
    companyNotification: PropTypes.object,
  }).isRequired,
  hasNotification: PropTypes.bool,
  actions: PropTypes.shape({
    dismissNotification: PropTypes.func,
  }),
};

export default HeaderLayoutComponent;
